const API_BASE = '/api';

const buildQuery = params => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, String(value));
  });
  return search.toString();
};

const request = async (path, { params, method = 'GET', body } = {}) => {
  const query = params ? `?${buildQuery(params)}` : '';
  const res = await fetch(`${API_BASE}${path}${query}`, {
    method,
    headers: body ? { 'content-type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    const message = await res.text().catch(() => res.statusText);
    throw new Error(message || `Request failed (${res.status})`);
  }

  return res.json();
};

export const fetchGames = ({ q, category, tag, badge, sort, limit, offset } = {}) =>
  request('/games', { params: { q, category, tag, badge, sort, limit, offset } });

export const fetchGame = slug => request('/game', { params: { slug } });

export const incrementPlay = slug =>
  request('/play', { method: 'POST', body: { slug } });

export const fetchHomeRails = () => request('/home-rails');
